import { InjectionToken } from '@angular/core';
import { IMqttServiceOptions } from 'ngx-mqtt';
import { environment } from '../../environments/environment';


export class AppConfig {
  apiBaseUrl: string;
}

  export const APP_DI_CONFIG: AppConfig = {
    apiBaseUrl: '',
  };
  

export const APP_CONFIG = new InjectionToken<AppConfig>('app.config');